import Api from '../../Api';

export const getConfiguracoes= () => (
  Api.get('configuracoes')
);
